import { render, staticRenderFns } from "./systemMain.vue?vue&type=template&id=9a33cdc6&scoped=true&"
import script from "./systemMain.vue?vue&type=script&lang=js&"
export * from "./systemMain.vue?vue&type=script&lang=js&"
import style0 from "./systemMain.vue?vue&type=style&index=0&id=9a33cdc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a33cdc6",
  null
  
)

export default component.exports